import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ExportApi from "../../api/ExportApi";
import { toast } from "react-toastify";

export default function SellerOrder() {
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [fee_percentage_cancelled, setfee_percentage_cancelled] = useState('');
  const [fee_percentage_failedToShip, setfee_percentage_failedToShip] = useState('');
  const [fee_percentage_authenticationFailed, setfee_percentage_authenticationFailed] = useState('');

  const onSubmit = async () => {
    try {


      if (
        fee_percentage_cancelled === '' &&
        fee_percentage_failedToShip === '' &&
        fee_percentage_authenticationFailed === ''
      ) {
        toast.error("All fields are required.");
        return;
      }
      if (fee_percentage_cancelled === '') {
        toast.error("Cancelled fee percentage is required.");
        return;
      }
      if (fee_percentage_failedToShip === '') {
        toast.error("Failed to ship fee percentage is required.");
        return;
      }
      if (fee_percentage_authenticationFailed === '') {
        toast.error("Authentication failed fee percentage is required.");
        return;
      }
      setButtonDisabled(true);

      const formatPercentage = (value) => {
        if (value === '' || isNaN(value)) return '';
        return parseFloat(value).toFixed(2);
      };
      
      const requestData = {
        fee_percentage_cancelled: formatPercentage(fee_percentage_cancelled),
        fee_percentage_failedToShip: formatPercentage(fee_percentage_failedToShip),
        fee_percentage_authenticationFailed: formatPercentage(fee_percentage_authenticationFailed),
      };
      console.log(requestData,"requestData>>>321");
  
      const resp = await ExportApi.addSellerOrderCancelfee(requestData);
      if (resp?.data?.message === "Fee percentage updated successfully") {
        toast.success(resp.data.message);
        fetchData();
      } else {
        toast.error(resp.data.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setButtonDisabled(false);
    }
  };

  const fetchData = async () => {
    try {
      const res = await ExportApi.getSellerOrderCancelfee();
      const data = res?.data?.detail;

      setfee_percentage_cancelled(data?.fee_percentage_cancelled);
      setfee_percentage_failedToShip(data?.fee_percentage_failedToShip);
      setfee_percentage_authenticationFailed(data?.fee_percentage_authenticationFailed);
    } catch (error) {
      console.error('Error fetching seller order cancel fee data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle numeric input
  const handleInputChange = (e, setter) => {
    const value = e.target.value;
  
  
    if (/^\d*\.?\d{0,2}$/.test(value)) {
   
      if (value === '' || parseFloat(value) <= 99) {
        setter(value);
      }
    }
  };
  

  return (
    <>
      {isLoading ? (
        <div className="loader-icon" style={{ marginBlock: "80px" }}>
          <i className="fa-solid fa-spinner fa-spin-pulse"></i>
        </div>
      ) : (
        <div className="py-5">
          <p className="mb-4">
            If the order is cancelled by the seller, then there will be a processing fee of 10% of the original sale price.
          </p>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Enter percentage"
              value={fee_percentage_cancelled || ""}
              onChange={(e) => handleInputChange(e, setfee_percentage_cancelled)} // Handle numeric input
            />
          </div>

          <p className="mb-4">If the shipment has lapsed, processing fees will be 15% of the original sale price.</p>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Enter percentage"
              value={fee_percentage_failedToShip || ""}
              onChange={(e) => handleInputChange(e, setfee_percentage_failedToShip)} // Handle numeric input
            />
          </div>

          <p className="mb-4">If authentication fails, then processing fees will be 15% of the original sale price.</p>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Enter percentage"
              value={fee_percentage_authenticationFailed || ""}
              onChange={(e) => handleInputChange(e, setfee_percentage_authenticationFailed)} // Handle numeric input
            />
          </div>

          <Button onClick={onSubmit} variant="primary" type="submit" className="mt-2" disabled={isButtonDisabled}>
            {isButtonDisabled ? 'Submitting...' : 'Submit'}
          </Button>
        </div>
      )}
    </>
  );
}
